import { api } from "shared/api";
import { ChangeStatus } from "../model/types";
import { ApiResponse } from 'shared/model/types';

type PhoneResponse = {
  created: string,
  id: number,
  initiator: string,
  property1: string,
  property2: string,
  reason: string | null,
  status: ChangeStatus,
  tokenCreated: string,
  type: 'PHONE',
  updateResults: {
    userUpdated: boolean,
    verificationUpdated: boolean,
    clientUpdated: boolean,
    updateNotification: boolean
  } | null,
  url: null,
  verificationToken: string | null,
};

export const phoneChangeApi = api.injectEndpoints({
  endpoints: (build) => ({
    requestPhoneChange: build.mutation<ApiResponse<PhoneResponse>, {
      phone: string;
      phoneCountry: number;
    }>({
      query: ({ phone, phoneCountry }) => ({
        url: 'user/change/request/phone',
        method: 'POST',
        params: { phone, phoneCountry },
      }),
    }),

    resendPhoneRequest: build.mutation<unknown, {
      requestId: number;
    }>({
      query: ({ requestId }) => ({
        url: `user/change/request/phone/${requestId}`,
        method: 'POST',
      }),
    }),

    confirmPhoneChange: build.mutation<ApiResponse<PhoneResponse>, {
      requestId: number;
      code: string;
    }>({
      query: ({ requestId, code }) => ({
        url: `user/change/confirm/phone/${requestId}/${code}`,
        method: 'PUT',
      }),
    }),
  }),
});

export const {
  useRequestPhoneChangeMutation,
  useResendPhoneRequestMutation,
  useConfirmPhoneChangeMutation,
} = phoneChangeApi;
